import { Translator } from '@itarget/shared'

export const useTranslation = () => ({
  title: Translator({ transRef: 'translation.Campanha de pontos/cash' }).props.children,
  message: Translator({ transRef: 'translation.Você ainda não aderiu ao programa de pontos. Deseja participar da campanha?' }).props
    .children,
  allowedMessage: Translator({
    transRef: 'translation.Sucesso! Participação confirmada! Acesse sua carteira de pontos no seu perfil de usuário.',
  }).props.children,
  rejectedMessage: Translator({
    transRef:
      'translation.Você optou por não aceitar os termos, mas poderá aderir ao nosso programa de fidelidade a qualquer momento através do seu perfil.',
  }).props.children,
  terms: Translator({ transRef: 'translation.Ler termos e regras da campanha.' }).props.children,
  denied: Translator({ transRef: 'translation.Não desejo participar' }).props.children,
  allowed: Translator({ transRef: 'translation.Participar agora!' }).props.children,
  confirm: Translator({ transRef: 'translation.Ok entendi!' }).props.children,
})
